<template>
	<section class="btn_main_wrap">
		<p class="btn-title">
			{{ title }}
			<a v-if="lightBoxCopy.title" class="info-button_popin" @click="togglePopin">
				<svg class="icon-info_small">
					<use xlink:href="#icon-Info_small" />
				</svg>
			</a>
		</p>
		<ul class="btn-multi-choice btn_wrap" :data-tracking-id="dtmTitle">
			<template v-for="(item, index) in list">
				<li :key="index" v-if="item.data">
					<a class="btn" :class="`${whichButtonIsActive(item.data)}`" @click="updateActiveButton(item.data)" :data-tracking-label="index" v-html="item.title"></a>
				</li>
			</template>
		</ul>
		<lightbox :visible="lightboxVisible" v-on:close="lightboxVisible = false">
			<div class="lightbox-simple-content">
				<ul>
					<li>
						<span v-html="lightBoxCopy.title" />
						<p v-html="lightBoxCopy.subtitle" />
					</li>
				</ul>
			</div>
		</lightbox>
	</section>
</template>
<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
	props: {
		title: String,
		list: Object,
		active: [String, Number],
		lightBoxCopy: Object,
		dtmTitle: String,
		electricity: false,
	},
	data() {
		return {
			lightboxVisible: false,
			ActiveItem: this.active,
			lengthObj: "",
            lang2: null
		};
	},
	components: {
		Lightbox,
	},
	computed: {
		...mapState({
            lang: (state) => state.lang,
            country: (state) => state.country,
        }),
	},
	watch: {
		active: function(val) {
			this.ActiveItem = val;
		},
	},
    mounted () {
        this.getCountryCode();
    },
	methods: {
		dynamicTrackingBtn() {},
		togglePopin() {
			this.lightboxVisible = !this.lightboxVisible;
		},
		// fetch which button is active
		whichButtonIsActive(item) {
			if (item == this.ActiveItem) {
				return "active";
			}
		},

        getCountryCode() {
            let countryCodes = [
                {
                    key: 'france',
                    value: 'FR'
                },
                {
                    key: 'italy',
                    value: 'IT'
                },
                {
                    key: 'uk',
                    value: 'EN'
                },
                {
                    key: 'germany',
                    value: 'DE'
                },
                {
                    key: 'switzerland',
                    value: 'CH'
                },
                {
                    key: 'austria',
                    value: 'AT'
                },
                {
                    key: 'belgium',
                    value: 'BE'
                },
                {
                    key: 'luxembourg',
                    value: 'LU'
                },
                {
                    key: 'netherlands',
                    value: 'NL'
                },
                {
                    key: 'poland',
                    value: 'PL'
                },
                {
                    key: 'ukraine',
                    value: 'UA'
                },
                {
                    key: 'denmark',
                    value: 'DK'
                },
                {
                    key: 'sweden',
                    value: 'SE'
                },
                {
                    key: 'norge',
                    value: 'NO'
                },
                {
                    key: 'finland',
                    value: 'FI'
                },
                {
                    key: 'estonia',
                    value: 'EE'
                },
                {
                    key: 'lithuania',
                    value: 'LT'
                },
                {
                    key: 'latvia',
                    value: 'LV'
                },
                {
                    key: 'spain',
                    value: 'ES'
                },
                {
                    key: 'portugal',
                    value: 'PT'
                },
                {
                    key: 'russia',
                    value: 'RU'
                },
            ]
            this.lang2 =  countryCodes.filter(obj => obj.key == this.country)
        },
		// User click on a button
		updateActiveButton(item) {
            if (this.electricity) {
                dataLayer = [];
                let languageCode = this.lang === 'fr_FR' ? 'fr' : (this.lang === 'en_uk' ? 'en' : this.lang)
				dataLayer.toggleType = `FS ${this.lang2[0].value}_${languageCode} ARIYA 87KWH - 63KWH Model`;
                dataLayer.toggleValue = item === 2 ? "ARIYA 87KWH" : "ARIYA 63KWH";
				window._satellite.track("toggle");
			} else {
                let languageCode = this.lang === 'fr_FR' ? 'fr' : (this.lang === 'en_uk' ? 'en' : this.lang)
				dataLayer = [];
				dataLayer.toggleType = `FS ${this.lang2[0].value}_${languageCode} ARIYA PETROL - DIESEL`;
                dataLayer.toggleValue = item === 1 ? "PETROL" : "DIESEL";
				window._satellite.track("toggle");
			}
			// check if its already active
			if (item === this.ActiveItem) {
				return;
			}
			// update the Object list
			this.ActiveItem = item;
			// Emit the object list to the parent div
			this.$emit("event_parent", this.ActiveItem);
		},
	},
};
</script>
